import React from 'react'
import { Component } from 'react'
import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class Calificaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            consultaEspecifica: false,
            notificaciones: null,
            errores: null,
            tipoCalificacion: '',
            numeroNombre: [],
            escalafones: [],
            grados: [],
            cargos: [],
            serieBase: [],
            lugaresTrabajo: [],
            ubicacionesCentral: [],
            calificaciones: null,
            calificacionesJefe: null,
            calificacionesTribunal: null,
            datosMov: null,
            abrirModal: false,
            conFecha: false,
            fechaHasta: '',
            calificacionFun:{
                numeroFuncionario: '',
                nombreFuncionario: '',
                comentarios: '',
                escalafon: '',
                grado: '',
                cargo: '',
                anio: '',
                serie: '',
                lugar: '',
                lugarCentral: '',
                conSupervision: '',
                cantidadTrabajo: '',
                calidadLaboral: '',
                preocupacionServicio: '',
                conocimientoTrabajo: '',
                interesTrabajo: '',
                capacidadTrabajo: '',
                relacionesInterpersonales: '',
                asistenciaPuntualidad: '',
                cumplimientoNormas: '',
                supervision: '',
                logroMetas: '',
                iniciativa: '',
                compromiso: '',
                responsabilidad: '',
                promedioTotal: '',
                promedioRC: '',
                promedioCP: '',
                promedioCDF: '',
                aptitudesCSR: '',
            },
            modalDescargo: {
                realizaDescargo: 0,
                descargo: '',
            },

            checkedList: {
                listaCompleta: true,
                calificados: false,
                noCalificados: false,
            },

            checkedListFuncionario: {
                ambos: false,
                soloJefe: true,
                soloTribunal: false,
            }
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarCambiosCalificacion = this.manejarCambiosCalificacion.bind(this);
        this.manejarEnvioCalificacion = this.manejarEnvioCalificacion.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
        this.manejarEnvioNotificacion = this.manejarEnvioNotificacion.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.enviarModal = this.enviarModal.bind(this);
        this.manejarCambioModalDescargo = this.manejarCambioModalDescargo.bind(this);
        this.manejarConsultaDescargo = this.manejarConsultaDescargo.bind(this);
        this.manejarEnvioConsultaTribunal = this.manejarEnvioConsultaTribunal.bind(this);
        this.manejarEnvioCalificacionTribunal = this.manejarEnvioCalificacionTribunal.bind(this);
        this.cambioListado = this.cambioListado.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioConsultaAbatimientoTribunal = this.manejarEnvioConsultaAbatimientoTribunal.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
        this.manejarEnvioNotificacionTribunal = this.manejarEnvioNotificacionTribunal.bind(this);
        this.calcularPromedio = this.calcularPromedio.bind(this);
    }

    async componentDidMount(){


        //Seteo el año
        const fech = new Date();
        const anioAnterior = fech.getFullYear() - 1;
        this.setState(state => {
            const calActualizada = this.state.calificacionFun;
            calActualizada['anio'] = String(anioAnterior);
            return{
                calificacionFun: calActualizada,
            }
        })

        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, sessionStorage.numeroFuncionarioAsociado]);
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombreJefe.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const datosGrados = await fetch(`${Constantes.RUTA_API}/obtener_grados.php`);
        const datoGrado = await datosGrados.json();
        this.setState({
            grados: datoGrado,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });

    }
    render(){
        return (
            <>
                {sessionStorage.login && sessionStorage.tipoUsuario === '3'
                ?
                    <Container>
                        <h3>Calificaciones</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Tipo Calificación</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoCalificacion' value={this.state.tipoCalificacion} onChange={this.manejarCambiosDatos}>
                                            <option value={''}>CALIFICACION</option>
                                            <option value={0}>TRIMESTRAL</option>
                                            <option value={1}>ANUAL</option>
                                        </select>
                                    </Item>
                                </Grid>
                            </Grid>
                        </Box>
                        <br/>
                        {this.state.tipoCalificacion === '0'
                        ?
                            <Container>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell width={'16%'}>Número</StyledTableCell>
                                                <StyledTableCell width={'16%'}>Nombre</StyledTableCell>
                                                <StyledTableCell>Comentarios</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.calificacionFun.numeroFuncionario} onChange={this.manejarCambiosCalificacion}/></StyledTableCell>
                                                <StyledTableCell>{this.state.calificacionFun.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell><textarea style={{width:"100%", border:"2px solid #D6EAF8"}} id='comentarios' value={this.state.calificacionFun.comentarios} onChange={this.manejarCambiosCalificacion}/></StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCalificacion}>Enviar</button>
                            </Container>
                        :
                            this.state.tipoCalificacion === '1'
                            ?
                                <Container>
                                    <fieldset>
                                        <legend>Datos Funcionario</legend>
                                        <Box sx={{ flexGrow: 1}}>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={2.1}>
                                                    <Item>Número Funcionario</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.calificacionFun.numeroFuncionario} onChange={this.manejarCambiosCalificacion} type="number" />
                                                </Grid>
                                                <Grid item xs={1}>

                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Nombre Funcionario</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    {this.state.calificacionFun.nombreFuncionario !== ''
                                                    ?
                                                        <Item>{this.state.calificacionFun.nombreFuncionario}</Item>
                                                    :
                                                        null
                                                    }
                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Escalafón</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.calificacionFun.escalafon} onChange={this.manejarCambiosCalificacion}>
                                                        <option value=''>ESCALAFON</option>
                                                        {this.state.escalafones.map((name) =>
                                                            <option
                                                            key={name.idEscalafon}
                                                            value={name.idEscalafon}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </Grid>
                                                <Grid item xs={1}>

                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Serie</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='serie' value={this.state.calificacionFun.serie} onChange={this.manejarCambiosCalificacion} >
                                                        <option value={''}>SERIE CONCURSO</option>
                                                        {this.state.serieBase.map((name) =>
                                                            <option
                                                            key={name.idSerie}
                                                            value={name.idSerie}
                                                            >{name.descripcion}</option>
                                                        )}
                                                    </select>
                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Cargo</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.calificacionFun.cargo} onChange={this.manejarCambiosCalificacion}>
                                                        <option value=''>CARGO</option>
                                                        {this.state.cargos.map((name) =>
                                                            <option
                                                            key={name.idCargo}
                                                            value={name.idCargo}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </Grid>
                                                <Grid item xs={1}>

                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Grado</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado'  value={this.state.calificacionFun.grado} onChange={this.manejarCambiosCalificacion}>
                                                        <option value=''>GRADO</option>
                                                        {this.state.grados.map((name) =>
                                                            <option
                                                            key={name.idGrado}
                                                            value={name.idGrado}
                                                            >{name.descripcion}</option>
                                                            )}
                                                    </select>
                                                </Grid>
                                                <Grid item xs={2.1}>
                                                    <Item>Ubicación</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.calificacionFun.lugar} onChange={this.manejarCambiosCalificacion}>
                                                        <option value={''}>LUGAR</option>
                                                        {this.state.lugaresTrabajo.map((name) =>
                                                            <option
                                                            key={name.idLugaresTrabajo}
                                                            value={name.idLugaresTrabajo}
                                                            >{name.lugar}</option>
                                                            )}
                                                    </select>
                                                </Grid>
                                                <Grid item xs={1}>

                                                </Grid>
                                                {this.state.calificacionFun.lugar == '0'
                                                ?
                                                    <Grid item xs={2.1}>
                                                        <Item>Ubicación Central</Item>
                                                    </Grid>
                                                :
                                                    null
                                                }
                                                {this.state.calificacionFun.lugar == '0'
                                                ?
                                                    <Grid item xs={3}>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.calificacionFun.lugarCentral} onChange={this.manejarCambiosCalificacion}>
                                                            <option value={''}>LUGAR CENTRAL</option>
                                                            {this.state.ubicacionesCentral.map((name) =>
                                                                <option
                                                                key={name.idUbicacionesCentral}
                                                                value={name.idUbicacionesCentral}
                                                                >{name.descripcion}</option>
                                                                )}
                                                        </select>
                                                    </Grid>
                                                :
                                                    null
                                                }
                                                <Grid item xs={2.1}>
                                                    <Item>Supervisión</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='conSupervision' value={this.state.calificacionFun.conSupervision} onChange={this.manejarCambiosCalificacion}>
                                                        <option value={''}>SUPERVISION</option>
                                                        <option value={0}>NO</option>
                                                        <option value={1}>SI</option>
                                                    </select>
                                                </Grid>
                                                {this.state.calificacionFun.lugar == '0'
                                                ?
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                :
                                                    null
                                                }
                                                <Grid item xs={2.1}>
                                                    <Item>Año</Item>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.calificacionFun.anio} onChange={this.manejarCambiosCalificacion} type="number" />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </fieldset>
                                    <br/>
                                    <br/>
                                    <fieldset>
                                        <legend>EVALUACION DE DESEMPEÑO</legend>
                                        <fieldset>
                                            <legend>RENDIMIENTO Y CALIDAD</legend>
                                            <p>Puntajes del 1 al 5</p>
                                            <Box sx={{ flexGrow: 1}}>
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.1}>
                                                        <Item>Cantidad de trabajo</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cantidadTrabajo' value={this.state.calificacionFun.cantidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Calidad de la labor realizada</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='calidadLaboral' value={this.state.calificacionFun.calidadLaboral} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Procupación por el servicio o usuario</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='preocupacionServicio' value={this.state.calificacionFun.preocupacionServicio} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={6}>

                                                    </Grid>
                                                    <Grid item xs={4}>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Promedio</Item>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        {this.state.calificacionFun.promedioRC}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </fieldset>
                                        <fieldset>
                                            <legend>CONDICIONES PERSONALES</legend>
                                            <p>Puntajes del 1 al 5</p>
                                            <Box sx={{ flexGrow: 1}}>
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.1}>
                                                        <Item>Conocimiento del trabajo</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='conocimientoTrabajo' value={this.state.calificacionFun.conocimientoTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Interés por el trabajo</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='interesTrabajo' value={this.state.calificacionFun.interesTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Capacidad para realizar trabajos en grupo</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='capacidadTrabajo' value={this.state.calificacionFun.capacidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>relaciones interpersonales</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='relacionesInterpersonales' value={this.state.calificacionFun.relacionesInterpersonales} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Promedio</Item>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        {this.state.calificacionFun.promedioCP}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </fieldset>
                                        <fieldset>
                                            <legend>COMPORTAMIENTO DEL FUNCIONARIO</legend>
                                            <p>Puntajes del 1 al 5</p>
                                            <Box sx={{ flexGrow: 1}}>
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.1}>
                                                        <Item>Asistencia y puntualidad</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='asistenciaPuntualidad' value={this.state.calificacionFun.asistenciaPuntualidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Cumplimiento de normas e instrucciones</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cumplimientoNormas' value={this.state.calificacionFun.cumplimientoNormas} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Promedio</Item>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        {this.state.calificacionFun.promedioCDF}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </fieldset>
                                        <fieldset>
                                            <legend>APTITUDES EN CARGOS DE SUPERVISION Y RESPONSABILIDAD</legend>
                                            <p>Puntajes del 1 al 5</p>
                                            <Box sx={{ flexGrow: 1}}>
                                                <Grid container spacing={2} rowSpacing={1}>
                                                    <Grid item xs={2.1}>
                                                        <Item>Supervisión</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='supervision' value={this.state.calificacionFun.supervision} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Logro de metas</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='logroMetas' value={this.state.calificacionFun.logroMetas} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Iniciativa</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='iniciativa' value={this.state.calificacionFun.iniciativa} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Compromiso</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='compromiso' value={this.state.calificacionFun.compromiso} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Responsabilidad</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='responsabilidad' value={this.state.calificacionFun.responsabilidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Promedio</Item>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        {this.state.calificacionFun.aptitudesCSR}
                                                    </Grid>
                                                    <Grid item xs={4}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Promedio Total</Item>
                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        {this.state.calificacionFun.promedioTotal}
                                                    </Grid>
                                                    <Grid item xs={4}>

                                                    </Grid>
                                                    <Grid item xs={2.1}>
                                                        <Item>Observaciones</Item>
                                                    </Grid>
                                                    <Grid item xs={3}>

                                                    </Grid>
                                                    <Grid item xs={12}>
                                                    </Grid>
                                                </Grid>
                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='comentarios' value={this.state.calificacionFun.comentarios} onChange={this.manejarCambiosCalificacion}/>
                                            </Box>
                                        </fieldset>
                                    </fieldset>
                                    <br/>
                                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCalificacion}>Enviar</button>
                                    <br/>
                                    <br/>
                                </Container>
                            :
                                null
                        }
                    </Container>
                :
                    sessionStorage.login && sessionStorage.tipoUsuario === '4'
                    ?
                        <Container>
                            <h3>Calificaciones</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        </Container>
                    :
                        sessionStorage.login && sessionStorage.tipoUsuario === '2'
                        ?
                            <Container>
                                <h3>Calificaciones</h3>
                                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                <br/>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>Tipo Calificación</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoCalificacion' value={this.state.tipoCalificacion} onChange={this.manejarCambiosDatos}>
                                                <option value={''}></option>
                                                <option value={0}>TRIMESTRAL</option>
                                                <option value={1}>ANUAL (JEFE)</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={0.5}>

                                        </Grid>
                                        {this.state.tipoCalificacion === '1'
                                        ?
                                            <Grid item xs={2.5}>
                                                <Item>Año</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.tipoCalificacion === '1'
                                        ?
                                            <Grid item xs={1.5}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.calificacionFun.anio} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                        :
                                            null
                                        }
                                    </Grid>
                                </Box>
                                {this.state.tipoCalificacion === '0' || this.state.tipoCalificacion === '1'
                                ?
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>
                                :
                                    null
                                }
                                <br/>
                                {this.state.tipoCalificacion === '0'
                                ?
                                    <Container>
                                        <br/>
                                        {this.state.calificaciones
                                        ?
                                            <Container>
                                                <Box sx={{ flexGrow: 1}}>
                                                    {this.state.calificaciones.map((name) => (
                                                        <Grid key={name.idCalificacionesJefes} container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.1}>
                                                                <Item>Número Funcionario</Item>
                                                            </Grid>
                                                            <Grid item xs={3.4}>
                                                                {name.numeroFuncionario}
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.1}>
                                                                <Item>Nombre Funcionario</Item>
                                                            </Grid>
                                                            <Grid item xs={3.4}>
                                                                {name.nombreFuncionario}
                                                            </Grid>
                                                            <Grid item xs={2.1}>
                                                                <Item>Período</Item>
                                                            </Grid>
                                                            <Grid item xs={3.4}>
                                                                {name.periodo}
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.1}>
                                                                <Item>Calificado Por</Item>
                                                            </Grid>
                                                            <Grid item xs={3.4}>
                                                                {name.calificadoPor}
                                                            </Grid>
                                                            <Grid item xs={5}>

                                                            </Grid>
                                                            <Grid item xs={2.1}>
                                                                <Item>Comentarios</Item>
                                                            </Grid>
                                                            <Grid item xs={3.5}>

                                                            </Grid>
                                                            <Grid item>
                                                                {name.comentarios}
                                                            </Grid>
                                                            <Grid item xs={26}>

                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </Box>
                                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                                            </Container>
                                        :
                                            null
                                        }
                                    </Container>
                                    :
                                        this.state.tipoCalificacion === '1'
                                        ?
                                            <Container>
                                                <br/>
                                                {this.state.calificaciones
                                                ?
                                                    <Container>
                                                        {/*this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null*/}
                                                        {/*<FormControlLabel label='Calificación Jefe/Tribunal' control={<Checkbox checked={this.state.checkedListFuncionario.ambos} onChange={this.cambioListadoConsulta} id='ambos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                                        <FormControlLabel label='Calificación Jefe' control={<Checkbox checked={this.state.checkedListFuncionario.soloJefe} onChange={this.cambioListadoConsulta} id='soloJefe' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                                                        <FormControlLabel label='Calificación Tribunal' control={<Checkbox checked={this.state.checkedListFuncionario.soloTribunal} onChange={this.cambioListadoConsulta} id='soloTribunal' inputProps={{ 'aria-label': 'controlled' }} /> }/>*/}
                                                        <fieldset>
                                                            <legend>DATOS FUNCIONARIO</legend>
                                                            <fieldset>
                                                                <Box sx={{ flexGrow: 1}}>
                                                                    <Grid container spacing={2} rowSpacing={1}>
                                                                        <Grid item xs={2}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Número Funcionario</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.numeroFuncionario}
                                                                        </Grid>
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Nombre Funcionario</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.nombreFuncionario}
                                                                        </Grid>
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Escalafon</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.escalafon}
                                                                        </Grid>
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Serie</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.serie}
                                                                        </Grid>
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Cargo</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.cargo}
                                                                        </Grid>
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Grado</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.grado}
                                                                        </Grid>
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Ubicación</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.lugar}
                                                                        </Grid>
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        {this.state.calificaciones.lugarCentral !== -1
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                <Item>Ubicación Central</Item>
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        {this.state.calificaciones.lugarCentral !== -1
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.lugarCentral}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        {this.state.calificaciones.lugarCentral !== -1
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={2}>
                                                                            <Item>Supervisión</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.conSupervision}
                                                                        </Grid>
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Año</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.anio}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            </fieldset>
                                                            <fieldset>
                                                                <legend>RENDIMIENTO Y CALIDAD</legend>
                                                                <p>Puntajes del 1 al 5</p>
                                                                <Box sx={{ flexGrow: 1}}>
                                                                    <Grid container spacing={2} rowSpacing={1}>
                                                                        <Grid item xs={2}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Cantidad de trabajo</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.cantidadTrabajo}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Calidad de la labor realizada</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.calidadLaboral}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Procupación por el servicio o usuario</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.preocupacionServicio}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Promedio</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.promedioRC}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                    </Grid>
                                                                </Box>
                                                            </fieldset>
                                                            <fieldset>
                                                                <legend>CONDICIONES PERSONALES</legend>
                                                                <p>Puntajes del 1 al 5</p>
                                                                <Box sx={{ flexGrow: 1}}>
                                                                    <Grid container spacing={2} rowSpacing={1}>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Conocimiento del trabajo</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.conocimientoTrabajo}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Interés por el trabajo</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.interesTrabajo}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Capacidad para realizar trabajos en grupo</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.capacidadTrabajo}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>relaciones interpersonales</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.relacionesInterpersonales}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Promedio</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.promedioCP}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                    </Grid>
                                                                </Box>
                                                            </fieldset>
                                                            <fieldset>
                                                                <legend>COMPORTAMIENTO DEL FUNCIONARIO</legend>
                                                                <p>Puntajes del 1 al 5</p>
                                                                <Box sx={{ flexGrow: 1}}>
                                                                    <Grid container spacing={2} rowSpacing={1}>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Asistencia y puntualidad</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.asistenciaPuntualidad}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Cumplimiento de normas e instrucciones</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.cumplimientoNormas}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Promedio</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.promedioCDF}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                    </Grid>
                                                                </Box>
                                                            </fieldset>
                                                            <fieldset>
                                                                <legend>APTITUDES EN CARGOS DE SUPERVISION Y RESPONSABILIDAD</legend>
                                                                <p>Puntajes del 1 al 5</p>
                                                                <Box sx={{ flexGrow: 1}}>
                                                                    <Grid container spacing={2} rowSpacing={1}>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Supervisión</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.supervision}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Logro de metas</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.logroMetas}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Iniciativa</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.iniciativa}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Compromiso</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.compromiso}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Responsabilidad</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.responsabilidad}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={1}>

                                                                        </Grid>
                                                                        <Grid item xs={5}>

                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Promedio</Item>
                                                                        </Grid>
                                                                        {this.state.checkedListFuncionario.soloJefe
                                                                        ?
                                                                            <Grid item xs={2}>
                                                                                {this.state.calificaciones.aptitudesCSR}
                                                                            </Grid>
                                                                        :
                                                                            null
                                                                        }
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Promedio Total</Item>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            {this.state.calificaciones.puntaje}
                                                                        </Grid>
                                                                        <Grid item xs={5}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Observaciones</Item>
                                                                        </Grid>
                                                                        <Grid item xs={3}>

                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='comentarios' value={this.state.calificaciones.comentarios} disabled/>
                                                                        </Grid>
                                                                        <Grid item xs={3}>

                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                            <Item>¿Desea realizar un descargo?</Item>
                                                                        </Grid>
                                                                        {(this.state.calificaciones.estadoCalificacion === 0)
                                                                        ?
                                                                            <Grid item xs={3}>
                                                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='realizaDescargo'  value={this.state.modalDescargo.realizaDescargo} onChange={this.manejarCambioModalDescargo}>
                                                                                    <option key={0} value={0}>NO</option>
                                                                                    <option key={1} value={1}>SI</option>
                                                                                </select>
                                                                            </Grid>
                                                                        :
                                                                            <Grid item xs={3}>
                                                                                <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='realizaDescargo'  value={this.state.modalDescargo.realizaDescargo} onChange={this.manejarCambioModalDescargo}>
                                                                                    <option key={0} value={0}>NO</option>
                                                                                    <option key={1} value={1}>SI</option>
                                                                                </select>
                                                                            </Grid>
                                                                        }
                                                                        <Grid item xs={3}>

                                                                        </Grid>
                                                                        <Grid item xs={5}>

                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Item>Descargo</Item>
                                                                        </Grid>
                                                                        <Grid item xs={5}>

                                                                        </Grid>
                                                                        {(this.state.calificaciones.estadoCalificacion === 0) && (this.state.modalDescargo.realizaDescargo === '1')
                                                                        ?
                                                                            <Grid item xs={12}>
                                                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='descargo' value={this.state.modalDescargo.descargo} onChange={this.manejarCambioModalDescargo} />
                                                                            </Grid>
                                                                        :
                                                                            <Grid item xs={12}>
                                                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='descargo' value={this.state.calificaciones.descargoFuncionario} disabled />
                                                                            </Grid>
                                                                        }
                                                                    </Grid>
                                                                </Box>
                                                            </fieldset>
                                                        </fieldset>
                                                        {this.state.calificaciones.estadoCalificacion === 0
                                                        ?
                                                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioNotificacion}>Notificar</button>
                                                        :
                                                            this.state.calificaciones.estadoCalificacion === 4
                                                            ?
                                                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioNotificacionTribunal}>Notificar</button>
                                                            :
                                                                null
                                                        }
                                                        {/*this.state.calificaciones.estadoCalificacion === 4 ? <button className="btn btn-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null*/}
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                            </Container>
                                        :
                                            null
                                }
                                <br/>
                                <Modal open={this.state.abrirModal}>
                                    <form className='formulario1'>
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <Box sx={styleModal} >
                                            <h3 style={{textAlign:'center'}}>Notificar Evaluación</h3>
                                            <h6>Tiene 10 días habiles para realizar el descargo. {this.state.conFecha ? this.state.fechaHasta : null} </h6>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={6}>
                                                    <Item>¿Desea realizar un descargo?</Item>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='realizaDescargo'  value={this.state.modalDescargo.realizaDescargo} onChange={this.manejarCambioModalDescargo}>
                                                        <option value=''>DESCARGO</option>
                                                        <option key={0} value={0}>NO</option>
                                                        <option key={1} value={1}>SI</option>
                                                    </select>
                                                </Grid>
                                                <Grid item xs={2}>

                                                </Grid>
                                                {this.state.modalDescargo.realizaDescargo === '1'
                                                ?
                                                    <Grid item xs={48}>
                                                        <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='descargo' value={this.state.modalDescargo.descargo} onChange={this.manejarCambioModalDescargo} />
                                                    </Grid>
                                                :
                                                    null
                                                }
                                                <Grid item xs={2}>

                                                </Grid>
                                                <Grid item xs={4}>
                                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.enviarModal}>Enviar</button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </form>
                                </Modal>
                            </Container>
                        :
                            sessionStorage.login && sessionStorage.tipoUsuario === '7'
                            ?
                                <Container>
                                    <h3 style={{marginBottom: '1rem'}}>Calificaciones</h3>
                                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                    <Box sx={{ flexGrow: 1}} >
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2.5}>
                                                <Item>Consultar Funcionario/s</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.calificacionFun.numeroFuncionario} onChange={this.manejarCambiosCalificacion}/>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Año</Item>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.calificacionFun.anio} onChange={this.manejarCambiosCalificacion}/>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsultaTribunal}>Consultar</button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <br/>
                                    {this.state.calificaciones && (!this.state.consultaEspecifica)
                                    ?
                                        <Container>
                                            <FormControlLabel label='Todos los Funcionarios' control={<Checkbox checked={this.state.checkedList.listaCompleta} onChange={this.cambioListado} id='listaCompleta' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                                            <FormControlLabel label='Funcionarios Calificados' control={<Checkbox checked={this.state.checkedList.calificados} onChange={this.cambioListado} id='calificados' inputProps={{ 'aria-label': 'controlled' }} /> }/>
                                            <FormControlLabel label='Funcionarios No Calificados' control={<Checkbox checked={this.state.checkedList.noCalificados} onChange={this.cambioListado} id='noCalificados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                <Table sx={{minWidth: 700}}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell>Estado</StyledTableCell>
                                                            <StyledTableCell>Número</StyledTableCell>
                                                            <StyledTableCell>Nombre</StyledTableCell>
                                                            <StyledTableCell>Calificar</StyledTableCell>
                                                            <StyledTableCell>Abatimiento</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.calificaciones.map((name) => (
                                                        <StyledTableRow key={name.idCalificacionesJefes}>
                                                            {name.estadoCalificacion === 2 || name.estadoCalificacion === 3 ? <StyledTableCell style={{color:'red'}}>Pendiente de Calificación</StyledTableCell> : <StyledTableCell style={{color:'green'}}>Calificado</StyledTableCell>}
                                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                            <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnvioConsultaCalificacionTribunal(name)}>Consultar</button></StyledTableCell>
                                                            <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnvioConsultaAbatimientoTribunal(name)}>Consultar</button></StyledTableCell>
                                                        </StyledTableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Container>
                                    :
                                        null
                                    }
                                    {this.state.datosMov
                                    ?
                                        <Container>
                                            <h3>Datos Movimientos</h3>
                                            <h6>Funcionario {this.state.datosMov[0].numeroFuncionario } {this.state.datosMov[0].nombreFuncionario}</h6>
                                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                {this.state.datosMov[0].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR ENFERMEDAD</h6>
                                                        <Table sx={{minWidth: 700}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[0].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[0].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>

                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[1].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR ENFERMEDAD FAMILIAR</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[1].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[1].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[2].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR ESTUDIO/EXAMEN</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[2].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[2].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[3].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR EXTRAORDINARIA CON SUELDO</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[3].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[3].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[4].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR EXTRAORDINARIA SIN SUELDO</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[4].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[4].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[5].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS CON AVISO</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[5].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[5].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[6].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS SIN AVISO</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[6].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[6].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[7].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR SUSPENSION</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[7].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[7].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[8].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR MESA DE EXAMEN</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[8].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[8].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[9].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR ACCIDENTE TRABAJO BPS</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[9].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[9].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[10].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR INTERNACION FAMILIAR</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[10].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[10].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[11].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR ESTUDIO/PARCIAL</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[11].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[11].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[12].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR CERTIFICACION VIA ADMINISTRATIVA</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[12].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[12].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                                {this.state.datosMov[13].movimientos.length !== 0
                                                ?
                                                    <Container>
                                                        <br/>
                                                        <h6>FALTAS POR SUBSIDIO TRANSITORIO BPS</h6>
                                                        <Table sx={{minWidth: 700}} style={{marginTop:'2rem'}}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <StyledTableCell>Desde</StyledTableCell>
                                                                    <StyledTableCell>Hasta</StyledTableCell>
                                                                    <StyledTableCell>Días</StyledTableCell>
                                                                    <StyledTableCell>Total</StyledTableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {this.state.datosMov[13].movimientos.map((datoMov) => (
                                                                    <StyledTableRow key={datoMov.idMovimiento}>
                                                                        <StyledTableCell>{datoMov.desde}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.hasta}</StyledTableCell>
                                                                        <StyledTableCell>{datoMov.dias}</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableBody>
                                                                <StyledTableRow>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell></StyledTableCell>
                                                                    <StyledTableCell>{this.state.datosMov[13].total}</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </Container>
                                                :
                                                    null
                                                }
                                            </TableContainer>
                                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem', marginLeft:'1rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                                        <br/>
                                        <br/>
                                        </Container>
                                    :
                                        null
                                    }
                                    <br/>
                                    {this.state.calificacionesJefe
                                    ?
                                        <Container>
                                            <fieldset>
                                                <legend>DATOS FUNCIONARIO</legend>
                                                <fieldset>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.3}>
                                                                <Item>Número Funcionario</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.numeroFuncionario}</Item>
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Nombre Funcionario</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.nombreFuncionario}</Item>
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Escalafon</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.escalafon}</Item>
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Serie</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.serie}</Item>
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Cargo</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.cargo}</Item>
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Grado</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.grado}</Item>
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Ubicación</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.lugar}</Item>
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            {this.state.calificacionesJefe.lugarCentral !== -1
                                                            ?
                                                                <Grid item xs={2.3}>
                                                                    <Item>Ubicación Central</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.calificacionesJefe.lugarCentral !== -1
                                                            ?
                                                                <Grid item xs={3.2}>
                                                                    <Item>{this.state.calificacionesJefe.lugarCentral}</Item>
                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            <Grid item xs={2.3}>
                                                                <Item>Supervisión</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.conSupervision}</Item>
                                                            </Grid>
                                                            {this.state.calificacionesJefe.lugarCentral !== -1
                                                            ?
                                                                <Grid item xs={1}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            <Grid item xs={2.3}>
                                                                <Item>Año</Item>
                                                            </Grid>
                                                            <Grid item xs={3.2}>
                                                                <Item>{this.state.calificacionesJefe.anio}</Item>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </fieldset>
                                                <fieldset>
                                                <legend>RENDIMIENTO Y CALIDAD</legend>
                                                    <p>Puntajes del 1 al 5</p>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.3}>
                                                                <Item>Cantidad de trabajo</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item >{this.state.calificacionesJefe.cantidadTrabajo}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cantidadTrabajo' value={this.state.calificacionFun.cantidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Calidad de la labor realizada</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.calidadLaboral}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='calidadLaboral' value={this.state.calificacionFun.calidadLaboral} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Procupación por el servicio o usuario</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.preocupacionServicio}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='preocupacionServicio' value={this.state.calificacionFun.preocupacionServicio} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </fieldset>
                                                <fieldset>
                                                <legend>CONDICIONES PERSONALES</legend>
                                                    <p>Puntajes del 1 al 5</p>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.3}>
                                                                <Item>Conocimiento del trabajo</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.conocimientoTrabajo}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='conocimientoTrabajo' value={this.state.calificacionFun.conocimientoTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Interés por el trabajo</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.interesTrabajo}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='interesTrabajo' value={this.state.calificacionFun.interesTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Capacidad para realizar trabajos en grupo</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.capacidadTrabajo}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='capacidadTrabajo' value={this.state.calificacionFun.capacidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>relaciones interpersonales</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.relacionesInterpersonales}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='relacionesInterpersonales' value={this.state.calificacionFun.relacionesInterpersonales} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </fieldset>
                                                <fieldset>
                                                    <legend>COMPORTAMIENTO DEL FUNCIONARIO</legend>
                                                    <p>Puntajes del 1 al 5</p>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.3}>
                                                                <Item>Asistencia y puntualidad</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.asistenciaPuntualidad}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='asistenciaPuntualidad' value={this.state.calificacionFun.asistenciaPuntualidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Cumplimiento de normas e instrucciones</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.cumplimientoNormas}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cumplimientoNormas' value={this.state.calificacionFun.cumplimientoNormas} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </fieldset>
                                                <fieldset>
                                                    <legend>APTITUDES EN CARGOS DE SUPERVISION Y RESPONSABILIDAD</legend>
                                                    <p>Puntajes del 1 al 5</p>
                                                    <Box sx={{ flexGrow: 1}}>
                                                        <Grid container spacing={2} rowSpacing={1}>
                                                            <Grid item xs={2.3}>
                                                                <Item>Supervisión</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.supervision}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='supervision' value={this.state.calificacionFun.supervision} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Logro de metas</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.logroMetas}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='logroMetas' value={this.state.calificacionFun.logroMetas} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Iniciativa</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.iniciativa}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='iniciativa' value={this.state.calificacionFun.iniciativa} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Compromiso</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.compromiso}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='compromiso' value={this.state.calificacionFun.compromiso} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Responsabilidad</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <Item>{this.state.calificacionesJefe.responsabilidad}</Item>
                                                            </Grid>
                                                            <Grid item xs={1.6}>
                                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='responsabilidad' value={this.state.calificacionFun.responsabilidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                                            </Grid>
                                                            <Grid item xs={6.5}>

                                                            </Grid>
                                                            <Grid item xs={5}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Observaciones (Jefe)</Item>
                                                            </Grid>
                                                            <Grid item xs={4.7}>

                                                            </Grid>
                                                            <Grid item>
                                                                <Item>{this.state.calificacionesJefe.comentarios}</Item>
                                                            </Grid>
                                                            {this.state.calificacionesJefe.descargoFuncionario !== ''
                                                            ?
                                                                <Grid item xs={6.5}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.calificacionesJefe.descargoFuncionario !== ''
                                                            ?
                                                                <Grid item xs={5}>

                                                                </Grid>
                                                            :
                                                                null
                                                            }
                                                            {this.state.calificacionesJefe.descargoFuncionario !== ''
                                                            ?
                                                                <Grid item xs={2.3}>
                                                                    <Item>Descargo Funcionario</Item>
                                                                </Grid>
                                                            :
                                                                <Grid item xs={4}>
                                                                    
                                                                </Grid>
                                                            }
                                                            <Grid item xs={4.7}>

                                                            </Grid>
                                                            {this.state.calificacionesJefe.descargoFuncionario !== ''
                                                            ?
                                                                <Grid item>
                                                                    <Item>{this.state.calificacionesJefe.descargoFuncionario}</Item>
                                                                </Grid>
                                                            :
                                                                <Grid item>
                                                                    <p style={{color: 'red', fontSize: '15px'}}>No hay descargo por parte del funcionario</p>
                                                                </Grid>
                                                            }
                                                            <Grid item xs={6.5}>

                                                            </Grid>
                                                            <Grid item xs={5}>

                                                            </Grid>
                                                            <Grid item xs={2.3}>
                                                                <Item>Observaciones (Tibunal)</Item>
                                                            </Grid>
                                                            <Grid item xs={4.7}>

                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='comentarios' value={this.state.calificacionFun.comentarios} onChange={this.manejarCambiosCalificacion}/>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </fieldset>
                                            </fieldset>
                                            <br/>
                                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem', marginLeft:'1rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCalificacionTribunal}>Enviar</button>
                                            <br/>
                                        </Container>
                                    :
                                        null
                                    }
                                    <br/>
                                </Container>
                            :
                                <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render

    async calcularPromedio(valor, clave){
        let promedio = 0;
        const cargaUtil = JSON.stringify([this.state.calificacionFun, valor, clave]);

        const control = await fetch(`${Constantes.RUTA_API}/calcular_promedio.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState(state => {
            const calificacionActu = state.calificacionFun;
            calificacionActu['promedioTotal'] = res[0];
            calificacionActu['promedioRC'] = res[1];
            calificacionActu['promedioCP'] = res[2];
            calificacionActu['promedioCDF'] = res[3];
            calificacionActu['aptitudesCSR'] = res[4];
            return{
                calificacionFun: calificacionActu,
            };
        })
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        let valor = e.target.value;
        const fech = new Date();
        const anioAnterior = fech.getFullYear() - 1;
        this.setState({
            calificaciones: null,
            calificacionesTribunal: null,
            calificacionesJefe: null,
            datosMov: null,
            errores: null,
            notificaciones: null,
            tipoCalificacion: valor,
            abrirModal: false,
            calificacionFun:{
                numeroFuncionario: '',
                nombreFuncionario: '',
                comentarios: '',
                escalafon: '',
                grado: '',
                cargo: '',
                anio: anioAnterior,
                serie: '',
                lugar: '',
                lugarCentral: '',
                conSupervision: '',
                cantidadTrabajo: '',
                calidadLaboral: '',
                preocupacionServicio: '',
                conocimientoTrabajo: '',
                interesTrabajo: '',
                capacidadTrabajo: '',
                relacionesInterpersonales: '',
                asistenciaPuntualidad: '',
                cumplimientoNormas: '',
                supervision: '',
                logroMetas: '',
                iniciativa: '',
                compromiso: '',
                responsabilidad: '',
                promedioTotal: '',
                promedioRC: '',
                promedioCP: '',
                promedioCDF: '',
                aptitudesCSR: '',
            },
            checkedListFuncionario: {
                ambos: false,
                soloJefe: true,
                soloTribunal: false,
            },
        })
    }

    manejarCambiosCalificacion(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.calcularPromedio(valor, clave);
        this.setState({
            errores: null,
            notificaciones: null,
            calificaciones: null,
            calificacionesTribunal: null,
            datosMov: null,
            //calificacionesJefe: null,
            checkedListFuncionario: {
                ambos: false,
                soloJefe: true,
                soloTribunal: false,
            },
        })
        this.setState(state => {
            const calificacionActu = state.calificacionFun;
            if((clave === 'numeroFuncionario') && (valor !== '')){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                    {if(name.numeroFuncionario === valor){
                        calificacionActu['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                        aux = false;
                    }else if(aux){
                        calificacionActu['nombreFuncionario'] = '';
                    }
                });
            }else if((clave === 'numeroFuncionario') && (valor === '')){
                calificacionActu['nombreFuncionario'] = '';
            }
            if(sessionStorage.tipoUsuario === '7'){
                if(clave !== 'comentarios'){
                    if((Number(valor) < 0) || (Number(valor) > 5)){
                        calificacionActu[clave] = '';
                        return{
                            calificacionFun: calificacionActu,
                            errores: 'El valor debe estar entre 0 y 5',
                        };
                    }else{
                        calificacionActu[clave] = valor;
                        return{
                            calificacionFun: calificacionActu,
                        };
                    }
                }else{
                    calificacionActu[clave] = valor;
                    return{
                        calificacionFun: calificacionActu,
                    };
                }
            }else{
                calificacionActu[clave] = valor;
                return{
                    calificacionFun: calificacionActu,
                };
            }
        });
    }

    async manejarEnvioCalificacion(e){
        e.preventDefault();
        if(this.state.calificacionFun.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            })
        }else if(this.state.calificacionFun.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido!',
            })
        }else if(this.state.calificacionFun.comentarios === ''){
            this.setState({
                errores: 'Debe ingresar un comentario sobre el desempeño del funcionario!',
            })
        }else if((this.state.calificacionFun.escalafon === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el escalafon!',
            })
        }else if((this.state.calificacionFun.grado === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el grado!',
            })
        }else if((this.state.calificacionFun.cargo === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el cargo!',
            })
        }else if((this.state.calificacionFun.serie === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el serie!',
            })
        }else if((this.state.calificacionFun.lugar === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el lugar!',
            })
        }else if((this.state.calificacionFun.lugar === '0') && (this.state.calificacionFun.lugarCentral === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar el sector!',
            })
        }else if((this.state.calificacionFun.conSupervision === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe indicar si tiene gente a cargo o no!',
            })
        }else if((this.state.calificacionFun.cantidadTrabajo === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la cantidad de trabajo!',
            })
        }else if((this.state.calificacionFun.calidadLaboral === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la calidad de la labor realizada!',
            })
        }else if((this.state.calificacionFun.preocupacionServicio === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 por la preocupación por el servicio o usuario!',
            })
        }else if((this.state.calificacionFun.conocimientoTrabajo === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el conocimiento del trabajo!',
            })
        }else if((this.state.calificacionFun.interesTrabajo === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el interés por el trabajo!',
            })
        }else if((this.state.calificacionFun.capacidadTrabajo === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la capacidad para realizar trabajos en grupo!',
            })
        }else if((this.state.calificacionFun.relacionesInterpersonales === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para las relaciones interpersonales!',
            })
        }else if((this.state.calificacionFun.asistenciaPuntualidad === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la asistencia y puntualidad!',
            })
        }else if((this.state.calificacionFun.cumplimientoNormas === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el cumplimiento de normas e instrucciones!',
            })
        }else if((this.state.calificacionFun.supervision === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la supervisión!',
            })
        }else if((this.state.calificacionFun.logroMetas === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para los logros y metas!',
            })
        }else if((this.state.calificacionFun.iniciativa === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la iniciativa!',
            })
        }else if((this.state.calificacionFun.compromiso === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el compromiso!',
            })
        }else if((this.state.calificacionFun.responsabilidad === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la responsabilidad!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.calificacionFun, this.state.tipoCalificacion, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/guardar_calificacionJefe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            if(res === 'ok'){
                const fech = new Date();
                const anioAnterior = fech.getFullYear() - 1;
                this.setState({
                    errores: null,
                    notificaciones: 'La calificación fue agregada con exito!',
                    abrirModal: false,
                    calificacionFun:{
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        comentarios: '',
                        escalafon: '',
                        grado: '',
                        cargo: '',
                        anio: anioAnterior,
                        serie: '',
                        lugar: '',
                        lugarCentral: '',
                        conSupervision: '',
                        cantidadTrabajo: '',
                        calidadLaboral: '',
                        preocupacionServicio: '',
                        conocimientoTrabajo: '',
                        interesTrabajo: '',
                        capacidadTrabajo: '',
                        relacionesInterpersonales: '',
                        asistenciaPuntualidad: '',
                        cumplimientoNormas: '',
                        supervision: '',
                        logroMetas: '',
                        iniciativa: '',
                        compromiso: '',
                        responsabilidad: '',
                        promedioTotal: '',
                        promedioRC: '',
                        promedioCP: '',
                        promedioCDF: '',
                        aptitudesCSR: '',
                    },
                })
            }
        }
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        if((this.state.calificacionFun.anio === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe seleccionar el año de la calificación',
                notificaciones: null,
            });
        }else{
            const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.tipoCalificacion, this.state.calificacionFun.anio]);
            
            const control = await fetch(`${Constantes.RUTA_API}/obtener_calificacionFuncionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });
            
            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: null,
                    errores: null,
                    calificaciones: res[1],
                    calificacionesTribunal: null,
                    calificacionesJefe: null,
                    datosMov: null,
                    abrirModal: false,
                });
                if((res[1].descargoFuncionario !== '') && (res[1].descargoFuncionario !== null)){
                    this.setState(state => {
                        const descar = state.modalDescargo;
                        descar['realizaDescargo'] = 1;
                        return{
                            modalDescargo: descar,
                        };
                    });
                }
                if((res[1].estadoCalificacion === 2) || (res[1].estadoCalificacion === 3)){
                    this.setState({
                        notificaciones: 'La calificación ya fue enviada',
                    });
                }
            }
        }
    }
    async manejarEnvioNotificacion(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.calificacionFun.anio, 1, this.state.modalDescargo]);
            
        const control = await fetch(`${Constantes.RUTA_API}/actualizar_calificacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res,
        });

        if(res === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Funcionario Notificado',
                errores: null,
                calificaciones: null,
                calificacionesTribunal: null,
                calificacionesJefe: null,
                datosMov: null,
                abrirModal: false,
            })
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            abrirModal: false,
            conFecha: false,
            errores: null,
            notificaciones: null,
            modalDescargo: {
                realizaDescargo: '',
                descargo: '',
            },
        })
    }

    async enviarModal(e){
        e.preventDefault();
        if(this.state.modalDescargo.realizaDescargo === ''){
            this.setState({
                errores: 'Debe indicar si realiza un descargo',
            })
        }else if((this.state.modalDescargo.realizaDescargo === '1') && (this.state.modalDescargo.descargo === '')){
            this.setState({
                errores: 'Debe escribir un descargo',
            })
        }else{
            const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.calificacionFun.anio, -1, this.state.tipoCalificacion, this.state.modalDescargo]);
            
            const control = await fetch(`${Constantes.RUTA_API}/actualizar_calificacion.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            
            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Calificación enviada con exito',
                    errores: null,
                    abrirModal: false,
                    calificaciones: null,
                    calificacionesTribunal: null,
                });
            }
        }
    }

    manejarCambioModalDescargo(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        })
        this.setState(state => {
            const modalDescargoAct = state.modalDescargo;
            modalDescargoAct[clave] = valor;
            return{
                modalDescargo: modalDescargoAct,
            };
        });
    }

    async manejarConsultaDescargo(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.calificacionFun.anio, this.state.tipoCalificacion]);
            
        const control = await fetch(`${Constantes.RUTA_API}/obtener_diasDescargo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
        });
        
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                abrirModal: true,
                conFecha: true,
                fechaHasta: res[1],
            })
        }
    }

    async manejarEnvioConsultaTribunal(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.escalafon, 0]);
            
        const control = await fetch(`${Constantes.RUTA_API}/obtener_funcionariosCalTribunal.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            notificaciones: null,
            checkedList:{
                listaCompleta: true,
                calificados: false,
                noCalificados: false,
            }
        });
        
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                abrirModal: false,
                conFecha: false,
                calificaciones: res[1],
                calificacionesTribunal: null,
                calificacionesJefe: null,
                datosMov: null,
            })
        }
    }

    async manejarEnvioConsultaCalificacionTribunal(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            abrirModal: false,
            conFecha: false,
            //calificaciones: null,
            consultaEspecifica: true,
            calificacionesTribunal: null,
            calificacionesJefe: dato,
            datosMov: null,
        })
        this.setState(state => {
            const calificacionActu = state.calificacionFun;
            calificacionActu['numeroFuncionario'] = dato.numeroFuncionario;
            calificacionActu['nombreFuncionario'] = dato.nombreFuncionario;
            calificacionActu['escalafon'] = dato.escalafon;
            calificacionActu['serie'] = dato.serie;
            calificacionActu['cargo'] = dato.cargo;
            calificacionActu['grado'] = dato.grado;
            calificacionActu['lugar'] = dato.lugar;
            calificacionActu['lugarCentral'] = dato.lugarCentral;
            calificacionActu['conSupervision'] = dato.conSupervision;
            calificacionActu['anio'] = dato.anio;
            return{
                calificacionFun: calificacionActu,
            };
        })

        if(dato.estadoCalificacion === 4){
            this.setState(state => {
                const calificacionActu = state.calificacionFun;
                calificacionActu['cantidadTrabajo'] = dato.cantidadTrabajoTribunal;
                calificacionActu['calidadLaboral'] = dato.calidadLaboralTribunal;
                calificacionActu['preocupacionServicio'] = dato.preocupacionServicioTribunal;
                calificacionActu['conocimientoTrabajo'] = dato.conocimientoTrabajoTribunal;
                calificacionActu['interesTrabajo'] = dato.interesTrabajoTribunal;
                calificacionActu['capacidadTrabajo'] = dato.capacidadTrabajoTribunal;
                calificacionActu['relacionesInterpersonales'] = dato.relacionesInterpersonalesTribunal;
                calificacionActu['asistenciaPuntualidad'] = dato.asistenciaPuntualidadTribunal;
                calificacionActu['cumplimientoNormas'] = dato.cumplimientoNormasTribunal;
                calificacionActu['supervision'] = dato.supervisionTribunal;
                calificacionActu['logroMetas'] = dato.logroMetasTribunal;
                calificacionActu['iniciativa'] = dato.iniciativaTribunal;
                calificacionActu['compromiso'] = dato.compromisoTribunal;
                calificacionActu['responsabilidad'] = dato.responsabilidadTribunal;
                calificacionActu['comentarios'] = dato.descargoTribunal;
                return{
                    calificacionFun: calificacionActu,
                };
            })
        }
    }

    async manejarEnvioCalificacionTribunal(e){
        e.preventDefault();
        if(this.state.calificacionFun.comentarios === ''){
            this.setState({
                errores: 'Debe ingresar un comentario sobre el desempeño del funcionario!',
            })
        }else if((this.state.calificacionFun.escalafon === '')){
            this.setState({
                errores: 'Debe indicar el escalafon!',
            })
        }else if((this.state.calificacionFun.grado === '')){
            this.setState({
                errores: 'Debe indicar el grado!',
            })
        }else if((this.state.calificacionFun.cargo === '')){
            this.setState({
                errores: 'Debe indicar el cargo!',
            })
        }else if((this.state.calificacionFun.serie === '')){
            this.setState({
                errores: 'Debe indicar el serie!',
            })
        }else if((this.state.calificacionFun.lugar === '')){
            this.setState({
                errores: 'Debe indicar el lugar!',
            })
        }else if((this.state.calificacionFun.lugar === '0') && (this.state.calificacionFun.lugarCentral === '')){
            this.setState({
                errores: 'Debe indicar el sector!',
            })
        }else if((this.state.calificacionFun.conSupervision === '')){
            this.setState({
                errores: 'Debe indicar si tiene gente a cargo o no!',
            })
        }else if((this.state.calificacionFun.cantidadTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la cantidad de trabajo!',
            })
        }else if((this.state.calificacionFun.calidadLaboral === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la calidad de la labor realizada!',
            })
        }else if((this.state.calificacionFun.preocupacionServicio === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 por la preocupación por el servicio o usuario!',
            })
        }else if((this.state.calificacionFun.conocimientoTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el conocimiento del trabajo!',
            })
        }else if((this.state.calificacionFun.interesTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el interés por el trabajo!',
            })
        }else if((this.state.calificacionFun.capacidadTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la capacidad para realizar trabajos en grupo!',
            })
        }else if((this.state.calificacionFun.relacionesInterpersonales === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para las relaciones interpersonales!',
            })
        }else if((this.state.calificacionFun.asistenciaPuntualidad === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la asistencia y puntualidad!',
            })
        }else if((this.state.calificacionFun.cumplimientoNormas === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el cumplimiento de normas e instrucciones!',
            })
        }else if((this.state.calificacionFun.supervision === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la supervisión!',
            })
        }else if((this.state.calificacionFun.logroMetas === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para los logros y metas!',
            })
        }else if((this.state.calificacionFun.iniciativa === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la iniciativa!',
            })
        }else if((this.state.calificacionFun.compromiso === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el compromiso!',
            })
        }else if((this.state.calificacionFun.responsabilidad === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la responsabilidad!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/guardar_calificacionTribunal.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            if(res === 'ok'){
                const fech = new Date();
                const anioAnterior = fech.getFullYear() - 1;
                this.setState({
                    errores: null,
                    notificaciones: 'La calificación fue agregada con exito!',
                    abrirModal: false,
                    calificacionesJefe: null,
                    datosMov: null,
                    calificacionFun:{
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        comentarios: '',
                        escalafon: '',
                        grado: '',
                        cargo: '',
                        anio: anioAnterior,
                        serie: '',
                        lugar: '',
                        lugarCentral: '',
                        conSupervision: '',
                        cantidadTrabajo: '',
                        calidadLaboral: '',
                        preocupacionServicio: '',
                        conocimientoTrabajo: '',
                        interesTrabajo: '',
                        capacidadTrabajo: '',
                        relacionesInterpersonales: '',
                        asistenciaPuntualidad: '',
                        cumplimientoNormas: '',
                        supervision: '',
                        logroMetas: '',
                        iniciativa: '',
                        compromiso: '',
                        responsabilidad: '',
                        promedioTotal: '',
                        promedioRC: '',
                        promedioCP: '',
                        promedioCDF: '',
                        aptitudesCSR: '',
                    },
                })
            }
        }
    }

    async cambioListado(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,

            checkedListFuncionario: {
                ambos: true,
                soloJefe: false,
                soloTribunal: false,
            },
        });

        if(clave === 'listaCompleta'){

            const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.escalafon, 0]);
        
            const control = await fetch(`${Constantes.RUTA_API}/obtener_funcionariosCalTribunal.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                notificaciones: null,
                calificaciones: null,
                calificacionesTribunal: null,
                calificacionesTribunal: null,
            });
            
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    abrirModal: false,
                    conFecha: false,
                    calificaciones: res[1],
                    calificacionesTribunal: null,
                    calificacionesJefe: null,
                    datosMov: null,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        listaCompleta: true,
                        calificados: false,
                        noCalificados: false,
                    },
                });
            }
        }else if(clave === 'calificados'){
            const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.escalafon, 1]);
        
            const control = await fetch(`${Constantes.RUTA_API}/obtener_funcionariosCalTribunal.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                notificaciones: null,
                calificaciones: null,
            });
            
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    abrirModal: false,
                    conFecha: false,
                    calificaciones: res[1],
                    calificacionesTribunal: null,
                    calificacionesJefe: null,
                    datosMov: null,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        listaCompleta: false,
                        calificados: true,
                        noCalificados: false,
                    },
                });
            }
        }else if(clave === 'noCalificados'){


            const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.escalafon, 2]);
        
            const control = await fetch(`${Constantes.RUTA_API}/obtener_funcionariosCalTribunal.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                notificaciones: null,
                calificaciones: null,
            });
            
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    abrirModal: false,
                    conFecha: false,
                    calificaciones: res[1],
                    calificacionesTribunal: null,
                    calificacionesJefe: null,
                    datosMov: null,
                })
            }

            if(valor){
                this.setState({
                    checkedList: {
                        listaCompleta: false,
                        calificados: false,
                        noCalificados: true,
                    },
                });
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        const fech = new Date();
        const anioAnterior = fech.getFullYear() - 1;
        this.setState( {
            notificaciones: null,
            errores: null,
            //tipoCalificacion: '',
            //calificaciones: null,
            consultaEspecifica: false,
            calificacionesTribunal: null,
            calificacionesJefe: null,
            datosMov: null,
            abrirModal: false,
            conFecha: false,
            fechaHasta: '',
            calificacionFun:{
                numeroFuncionario: '',
                nombreFuncionario: '',
                comentarios: '',
                escalafon: '',
                grado: '',
                cargo: '',
                anio: String(anioAnterior),
                serie: '',
                lugar: '',
                lugarCentral: '',
                conSupervision: '',
                cantidadTrabajo: '',
                calidadLaboral: '',
                preocupacionServicio: '',
                conocimientoTrabajo: '',
                interesTrabajo: '',
                capacidadTrabajo: '',
                relacionesInterpersonales: '',
                asistenciaPuntualidad: '',
                cumplimientoNormas: '',
                supervision: '',
                logroMetas: '',
                iniciativa: '',
                compromiso: '',
                responsabilidad: '',
                promedioTotal: '',
                promedioRC: '',
                promedioCP: '',
                promedioCDF: '',
                aptitudesCSR: '',
            },
            modalDescargo: {
                realizaDescargo: '',
                descargo: '',
            },

            checkedList: {
                listaCompleta: true,
                calificados: false,
                noCalificados: false,
            },

            checkedListFuncionario: {
                ambos: false,
                soloJefe: true,
                soloTribunal: false,
            },
        });
    }

    async manejarEnvioConsultaAbatimientoTribunal(dato){
        this.setState({
            errores: null,
            notificaciones: null,
        });

        const cargaUtil = JSON.stringify(dato);

        const control = await fetch(`${Constantes.RUTA_API}/obtener_abatimientoCalificacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
        });
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                datosMov: res[1],
                consultaEspecifica: true,
                //calificaciones: null,
                calificacionesTribunal: null,
            })
        }
        /*const cargaUtil = JSON.stringify([this.state.calificacionFun, sessionStorage.escalafon, 2]);
        
        const control = await fetch(`${Constantes.RUTA_API}/obtener_funcionariosCalTribunal.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            notificaciones: null,
            calificaciones: null,
        });
        
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                abrirModal: false,
                conFecha: false,
                calificaciones: res[1],
                calificacionesJefe: null,
            })
        }*/

    }

    async cambioListadoConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'ambos'){

            if(valor){
                this.setState({
                    checkedListFuncionario: {
                        ambos: true,
                        soloJefe: false,
                        soloTribunal: false,
                    },
                });
            }
        }else if(clave === 'soloJefe'){

            if(valor){
                this.setState({
                    checkedListFuncionario: {
                        ambos: false,
                        soloJefe: true,
                        soloTribunal: false,
                    },
                });
            }
        }else if(clave === 'soloTribunal'){

            if(valor){
                this.setState({
                    checkedListFuncionario: {
                        ambos: false,
                        soloJefe: false,
                        soloTribunal: true,
                    },
                });
            }
        }
    }

    async manejarEnvioNotificacionTribunal(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.calificacionFun.anio, 5]);
            
        const control = await fetch(`${Constantes.RUTA_API}/actualizar_calificacion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res,
        });

        if(res === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Funcionario Notificado',
                abrirModal: true,
            })
        }
    }

}

export default Calificaciones